import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=3a7c7a8d&scoped=true&"
import script from "./SideMenu.vue?vue&type=script&lang=js&"
export * from "./SideMenu.vue?vue&type=script&lang=js&"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=3a7c7a8d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7c7a8d",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/elements/SideMenu.vue
// module id = null
// module chunks = 